<form [formGroup]="formGroup" (submit)="onSubmit()">
  <div class="setup-intro">
    <p>
      Use this tile to list tender items from a datasource. Choose the source and how many items
      should appear on each page.
    </p>
  </div>

  <app-data-source-selector
    formControlName="dataSource"
    hint="Chooses which datasource supplies the tender items."
  ></app-data-source-selector>

  <mat-form-field appearance="outline">
    <mat-label>Items per page</mat-label>
    <input matInput type="number" min="1" formControlName="itemsPerPage" />
    <mat-hint>Controls how many tender items are shown before pagination appears.</mat-hint>
    <mat-error *ngIf="formGroup.controls.itemsPerPage.invalid">Enter at least 1</mat-error>
  </mat-form-field>

  <button mat-flat-button color="primary" [disabled]="formGroup.invalid">Apply</button>
</form>
